import { Route } from 'vue-router';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalIndex from '@store/modules/ui/shared/modal/modalIndex';

export function useLoginBeforeNavigate() {
    const { router } = useVueRouter();
    const authStore = useVuexStore<AuthenticationStore>('data/authentication');
    const user = authStore.getter('user');
    const modalStore = useVuexStore<typeof modalIndex>('ui/modal');
    const setModal = modalStore.action('setModal');

    function loginBeforeNavigate(route: Route) {
        if (user.value) {
            router.value.push({
                name: route.name!,
            });
        } else {
            setModal({
                code: modalCodes.login,
                data: {
                    nextRouteAfterLogin: route,
                },
            });
        }
    }

    return {
        loginBeforeNavigate,
    };
}
